import { render, staticRenderFns } from "./FeeLogTable.vue?vue&type=template&id=20cbe51c&"
import script from "./FeeLogTable.vue?vue&type=script&lang=js&"
export * from "./FeeLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports